import api from "./api";

const syncService = {
  getStatus: () => api.get("/sync/status"),
  getRuns: (params) => api.get("/sync/runs", { params }),
  triggerSync: () => api.post("/sync/trigger"),
  testConnection: () => api.get("/sync/test-connection"),
  getConflicts: (params) => api.get("/sync/conflicts", { params }),
  resolveConflict: (id, payload) => api.post(`/sync/conflicts/${id}/resolve`, payload),
};

export default syncService;
